import React from "react";

const WorldCupSticker = ({ professor, rank, size = "large", style = {}, onClick }) => {
    if (!professor) return null;

    // Dimensões de tamanho para o layout de lista vertical
    const dimensions = {
        large: {
            width: "clamp(240px, 40vw, 320px)",
            height: "clamp(320px, 53.3vw, 426px)"
        },
        medium: {
            width: "200px",
            height: "266px"
        }
    };

    const config = dimensions[size] || dimensions.large;

    return (
        <div
            onClick={onClick}
            style={{
                position: "relative",
                width: config.width,
                height: config.height,
                borderRadius: "12px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                userSelect: "none",
                cursor: "pointer",
                overflow: "hidden",
                ...style
            }}
            onMouseOver={e => {
                e.currentTarget.style.transform = "scale(1.04) translateY(-6px)";
                e.currentTarget.style.boxShadow = "0 18px 35px rgba(0,0,0,0.6)";
                e.currentTarget.style.zIndex = 10;
            }}
            onMouseOut={e => {
                e.currentTarget.style.transform = "scale(1) translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.5)";
                e.currentTarget.style.zIndex = 1;
            }}
        >
            {/* Imagem que já é a figurinha completa */}
            <div style={{ width: "100%", height: "100%" }}>
                {professor.employeePhotoUrl ? (
                    <img
                        src={professor.employeePhotoUrl}
                        alt={professor.employeeName}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                        }}
                    />
                ) : (
                    <div
                        className="w-100 h-100 d-flex flex-column align-items-center justify-content-center fw-bold"
                        style={{
                            background: "linear-gradient(135deg, #11998E 0%, #38EF7D 100%)",
                            color: "#ffffff"
                        }}
                    >
                        <span style={{ fontSize: "36px" }}>{professor.employeeName?.charAt(0)}</span>
                        <span style={{ fontSize: "12px", marginTop: "6px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.85 }}>
                            {professor.employeeName?.split(" ")[0]}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorldCupSticker;
